import { render } from "./version-update.vue?vue&type=template&id=0b566b4a&scoped=true"
import script from "./version-update.vue?vue&type=script&lang=js"
export * from "./version-update.vue?vue&type=script&lang=js"

import "./version-update.vue?vue&type=style&index=0&id=0b566b4a&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b566b4a"]])

export default __exports__